import { render, staticRenderFns } from "./DobleFactorAutenticacion.vue?vue&type=template&id=bca5e37a"
import script from "./DobleFactorAutenticacion.vue?vue&type=script&lang=js"
export * from "./DobleFactorAutenticacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports